import { isEmpty, uniqBy } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { RoleResponse } from "~types/role.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect/InfinitySelect.tsx";

type Props = SelectBaseSingleProperties<InfinitySelectOption> & {
  personId?: string;
  seasonId?: string;
  fixtureId?: string;
};

const SelectRole = ({ value, personId, seasonId, fixtureId, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: RoleResponse) =>
    uniqBy(response?.data || [], "role").map((x) => ({ label: x.role, value: x.role }));

  const url = fixtureId ? `${sport}/o/${organizationId}/fixtures/${fixtureId}/roles` : `${sport}/o/${organizationId}/roles`;
  const filterParameters = fixtureId ? { personId } : { personId, seasonId };

  return (
    <InfinitySelect<RoleResponse>
      {...props}
      url={url}
      filterParameters={filterParameters}
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.ROLES}
      permissionOperation={PermissionOperations.READ}
      resetOptionsDependencies={[personId, fixtureId, seasonId]}
    />
  );
};

export default SelectRole;
